<template>
  <div class="helper-bottom-fix" v-if="helperHeightYn">
    <div class="helper-text" v-if="height >= 25">
      <img src="@/assets/images/user/img_bg_arrow_up.png" alt="" />
      <span>2/4</span>
      <img src="@/assets/images/user/img_bg_arrow_dn.png" alt="" />
    </div>
    <div class="helper-text2" v-if="height >= 50">
      <img src="@/assets/images/user/img_bg_arrow_up.png" alt="" />
      <span>3/4</span>
      <img src="@/assets/images/user/img_bg_arrow_dn.png" alt="" />
    </div>
    <div class="helper-text3" v-if="height == 75">
      <img src="@/assets/images/user/img_bg_arrow_up.png" alt="" />
      <span>4/4</span>
    </div>
    <button class="btn--line-w btn-left" @mouseup="reset()">{{ $t('User.HelperHeight.msg1') }}</button>
    <div class="btn-center">
      <button
        class="btn--helper"
        :class="{disabled: height == '-5.2' || height == 0}"
        :disabled="height == '-5.2' || height == 0"
        id="btnUp"
        @mouseup="screenUp()"
      >
        <span>{{ $t('User.HelperHeight.msg2') }}</span
        ><i class="ico-up"></i>
      </button>
      <button class="btn--helper" :class="{disabled: height == 75}" :disabled="height == 75" id="btnDown" @mouseup="screenDown()">
        <span>{{ $t('User.HelperHeight.msg3') }}</span
        ><i class="ico-down"></i>
      </button>
      <span class="txt">{{ $t('User.HelperHeight.msg4') }}</span>
    </div>
    <button class="btn--line-w btn-right" @mouseup="close()">{{ $t('User.HelperHeight.msg5') }}</button>
  </div>
</template>
<script>
export default {
  name: 'helperHeight',
  props: {
    helperHeightYn: Boolean,
  },
  data() {
    return {
      height: -5.2,
    };
  },
  methods: {
    close() {
      this.height = -5.2;
      let positions = document.querySelectorAll('.positions');
      for (var i = 0; i < positions.length; i++) {
        positions[i].style.marginTop = '0vh';
      }
      this.$store.commit('setHelperHeightYn');
    },
    reset() {
      this.height = -5.2;
      let positions = document.querySelectorAll('.positions');
      for (var i = 0; i < positions.length; i++) {
        positions[i].style.marginTop = '-5.2vh';
      }
    },
    screenUp() {
      this.height -= 25;
      let positions = document.querySelectorAll('.positions');
      for (var i = 0; i < positions.length; i++) {
        this.height = this.height == 0 ? '-5.2' : this.height;
        positions[i].style.marginTop = this.height + 'vh';
      }
    },
    screenDown() {
      this.height = this.height == '-5.2' ? 0 : this.height;
      this.height += 25;
      let positions = document.querySelectorAll('.positions');
      for (var i = 0; i < positions.length; i++) {
        positions[i].style.marginTop = this.height + 'vh';
      }
    },
  },
  mounted() {},
  watch: {
    helperHeightYn(val) {
      if (val) {
        setTimeout(() => {
          this.reset();
        }, 10);
      }
    },
  },
};
</script>
<style scoped>
</style>
